module.exports = __webpack_public_path__ + "static/hero-hcp-home-mobile-b2036be80d04b0b2a0877862dbf21afe.png";